<template>
  <Teleport to="body">
    <div v-show="open" class="modal-backdrop" @click.self="closeModal">
      <div class="modal-container" style="width: 600px">
        <div class="modal-header">
          <h5>Produtos do Pedido</h5>
          <button
            class="close-btn"
            @click="closeModal"
            aria-label="Fechar modal"
            type="button"
          >
          </button>
        </div>
        <div class="modal-body">
          <table class="table">
            <thead>
              <th style="width:80%">Produto</th>
              <th >Quantidade</th>
            </thead>
            <tbody>
              <tr >
                <td style="width:80%; word-break: break-word; white-space: normal; display: flex; gap:10px">
                  <img :src="item.produto.imagem" />
                  {{ item.produto.nome }}
                </td>
                <td style="text-align: center;">
                  {{ item.quantidade }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-sm-6">
              <label>Tamanho do corte (m)</label>
            <input type="text" class="form-control" v-model="item.tamanho"/>
            </div>
            
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-primary"
            @click="confirmSelection"
            aria-label="Confirmar seleção"
            type="button"
          >
            Selecionar
          </button>
          <button
            class="btn"
            @click="cancelar"
            aria-label="Confirmar seleção"
            type="button"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, defineProps, defineEmits, reactive } from "vue";

const props = defineProps({
  open: Boolean,
  pedido: { type: Object, default: null },
  item: { type: Object, default: null },
  width: { type: String, default: "600px" },
  readProductIds: { type: Array, default: () => [] },
});

const emit = defineEmits(["close", "confirm", "update:readProductIds"]);


function closeModal() {
  emit("close");
}

function confirmSelection() {
 // if (!props.pedido?.itens) return closeModal();
  emit("confirm", props.item);
  closeModal();
}

function cancelar() {
  if (!props.pedido?.itens) return closeModal();
  closeModal();
}


</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-container {
  background: white;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  max-height: 80vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 50%;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-footer {
  border-top: none;
  border-bottom: none;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}

.modal-body {
  padding: 1rem;
}

.custom-table thead tr {
  background-color: #560382;
  color: white;
}

.custom-table thead tr th {
  padding: 0.75rem 1rem;
  text-align: left;
}

.custom-table tbody tr {
  border-bottom: 1px solid #ddd;
}

.product-cell {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.product-image {
  width: 50px;
  height: 50px;
  object-fit: contain;
  border-radius: 4px;
}

.price-cell {
  width: 100px;
  font-weight: 600;
}

.quantity-cell {
  width: 60px;
  text-align: center;
}
.item-lido {
  background-color: #d4edda;
  color: #155724;
}
</style>
